import './App.css';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import NavAuth from './Components/NavAuth';
import { Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from './Components/PrivateRoute';
import { current } from './Redux/Actions/AuthActions';
import Register from './Components/Register';
import Login from './Components/Login';
import Errors from './Components/Errors';
import ListUser from './Components/ListUser';
import UpdateUser from './Components/UpdateUser';
import UpdateProfil from './Components/UpdateProfil';
import PublicReclamationForm from './Components/PublicReclamationForm';
import QRManagement from './Components/QRManagement';

import ApplicationFakhry from './Components/ApplicationFakhry';
import Welcome from './Components/Welcome';
import ChargeExp from './Components/ChargeExp';
import Menu from './Components/Menu';
import Addition from './Components/Addition';
import BillsFilter from './Components/BillsFilter';
import UpdateStock from './Components/UpdateStock';
import Deals from './Components/Deals';
import Valises from './Components/Valises';
import ProductValises from './Components/ProductValises';
import IngredientFormV from './Components/IngredientFormV';
import InvoiceVForm from './Components/InvoiceVForm';
import SupplierVForm from './Components/SupplierVForm';
import StockReportV from './Components/StockReportV';
import RealStock from './Components/RealStock';
import DealsV from './Components/DealsV';
import InvoiceVList from './Components/InvoiceVList';
import TicketCaisse from './Components/TicketCaisse';
import Marge from './Components/Marge';
import InvoiceDocList from './Components/InvoiceDocList';
import UploadInvoice from './Components/UploadInvoice';
import InvoiceView from './Components/InvoiceView';
import UpdateProduct from './Components/UpdateProduct';
import StockDetails from './Components/StockDetails';
import UpdateStockV from './Components/UpdateStockV';
import ChangeLocation from './Components/ChangeLocation';
import Event from './Components/Event';
import PackManagement from './Components/PackManagement';
import CheckInSystem from './Components/CheckInSystem';
import SubscribersList from './Components/SubscribersList';
import ProductRequestForm from './Components/ProductRequestForm';
import CentralizedRequests from './Components/CentralizedRequests';
import AdminApproval from './Components/AdminApproval';
import PurchaseList from './Components/PurchaseList';
import CategoryProductManager from './Components/CategoryProductManager.js';
import GlobalDashboard from './Components/GlobalDashboard.js';
import StaffCReport from './Components/StaffCReport.js';
import DeclarationEmployeur from './Components/DeclarationEmployeur';
import PointsGestion from './Components/PointsGestion.js';
import EtatDepenses from './Components/EtatDepenses';
import Rbe from './Components/Rbe';
import Rapports from './Components/Rapports';
import ListRapports from './Components/ListRapports';
import RapportsTwin from './Components/RapportsTwin';
import ListeRapportsTwin from './Components/ListeRapportsTwin';
import GestionEmplacements from './Components/GestionEmplacements';
import RapportsSpintoss from './Components/RapportsSpintoss';
import ListRapportsSpintoss from './Components/ListRapportsSpintoss';
import CollecteTwin from './Components/CollecteTwin';
import ListCollectTwin from './Components/ListCollectTwin';
import Home from './Components/Home';
import AdvancedAnalytics from './Components/AdvancedAnalytics';
import PointagePage from './Components/HR/PointagePage';
import EmployeesSchedule from './Components/HR/EmployeesSchedule';
import HRDashboard from './Components/HR/HRDashboard';
import EmployeeManager from './Components/EmployeeManager';
import SalaryManager from './Components/HR/SalaryManager';
import WellnessStats from './Components/Statistiques/WellnessStats';
import TwinparkStats from './Components/Statistiques/TwinparkStats';
import BagngoStats from './Components/Statistiques/BagngoStats';
import EspaceStats from './Components/Statistiques/EspaceStats';
import SpintossStats from './Components/Statistiques/SpintossStats';
import StatistiquesAchats from './Components/Statistiques/StatistiquesAchats';
import CaisseMobile from './Components/CaisseMobile';
import GestionCaissiers from './Components/GestionCaissiers';
import NfcInvoicePortal from './Components/NfcInvoicePortal';
import DiscountManagement from './Components/DiscountManagement';
import BrandStatsHub from './Components/BrandStatsHub';
import DailyPurchaseHub from './Components/DailyPurchases/DailyPurchaseHub';
import FundTransferHub from './Components/FundTransfers/FundTransferHub';
import FundTransferMobilePortal from './Components/FundTransfers/FundTransferMobilePortal';
import GestionAgentsTransfert from './Components/FundTransfers/GestionAgentsTransfert';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      dispatch(current());
    }
  }, [dispatch]);

  return (
    <div>

      <NavAuth />
      <Errors />
      <Routes>

        {/* Public Routes */}
        <Route path='/' element={<Navigate to='/welcome' replace />} />
        <Route path='/welcome' element={<Welcome />} />
        <Route path='/Welcome' element={<Navigate to='/welcome' replace />} />
        <Route path='/Login' element={<Login />} />
        <Route path='/CaisseMobile' element={<CaisseMobile />} />
        <Route path='/transfert-mobile' element={<FundTransferMobilePortal />} />
        <Route path='/caisse-transfert' element={<FundTransferMobilePortal />} />
        <Route path='/caisse-nfc/:locationId' element={<NfcInvoicePortal />} />
        <Route path='/nfc-invoice/:locationId' element={<NfcInvoicePortal />} />
        <Route path='/caisse-qr/:locationId' element={<NfcInvoicePortal />} />
        <Route path='/qr-invoice/:locationId' element={<NfcInvoicePortal />} />
        <Route path='/reclamation/:qrToken' element={<PublicReclamationForm />} />
        <Route path='/reclamation' element={<PublicReclamationForm />} />

        {/* Private / Protected Routes */}
        <Route element={<PrivateRoute />}>
          <Route path='/BrandStatsHub' element={<BrandStatsHub />} />
          <Route path='/Statistiques' element={<BrandStatsHub />} />
          <Route path='/StatistiquesEnseignes' element={<BrandStatsHub />} />
          <Route path='/GestionQR' element={<QRManagement />} />
          <Route path='/Statistiques/Wellness' element={<WellnessStats />} />
          <Route path='/Statistiques/Twinpark' element={<TwinparkStats />} />
          <Route path='/Statistiques/Bagngo' element={<BagngoStats />} />
          <Route path='/Statistiques/Espace' element={<EspaceStats />} />
          <Route path='/Statistiques/Spintoss' element={<SpintossStats />} />
          <Route path='/AddRapports' element={<Rapports />} />
          <Route path='/Accueil' element={<Navigate to='/Home' replace />} />
          <Route path='/Home' element={<Home/>}/>
          <Route path='/AdvancedAnalytics' element={<AdvancedAnalytics/>}/>
          <Route path='/Register' element={<Register />} />
          <Route path='/AllUser' element={<ListUser />} />
          <Route path='/UpdateUser/:id' element={<UpdateUser />} />
          <Route path='/UpdateProfil' element={<UpdateProfil />} />
          <Route path='/ApplicationFakhry' element={<ApplicationFakhry />} />
          <Route path='/AddChargeExp' element={<ChargeExp />} />
          <Route path='/AjoutFrsV' element={<SupplierVForm />} />
          <Route path='/AjoutArticle' element={<IngredientFormV />} />
          <Route path='/TicketCaisse' element={<TicketCaisse />} />
          <Route path='/GestionCaissiers' element={<GestionCaissiers />} />
          <Route path='/GestionRemises' element={<DiscountManagement />} />
          <Route path='/AjoutFactureV' element={<InvoiceVForm />} />
          <Route path='/ApercuStock' element={<StockReportV />} />
          <Route path='/ListProduct' element={<Menu />} />
          <Route path='/Addition' element={<Addition />} />
          <Route path='/TicketReport' element={<BillsFilter />} />
          <Route path='/UpdateStock' element={<UpdateStock />} />
          <Route path='/Deals' element={<Deals />} />
          <Route path='/DealsV' element={<DealsV />} />
          <Route path='/Valises' element={<Valises />} />
          <Route path='/CreaValises' element={<ProductValises />} />
          <Route path='/RealStock' element={<RealStock />} />
          <Route path='/ListFactureV' element={<InvoiceVList />} />
          <Route path='/MargeState' element={<Marge />} />
          <Route path='/UploadInvoice' element={<UploadInvoice />} />
          <Route path='/InvoiceDocList' element={<InvoiceDocList />} />
          <Route path='/InvoiceView' element={<InvoiceView />} />
          <Route path='/UpdateProduct' element={<UpdateProduct />} />
          <Route path='/StockDetails' element={<StockDetails />} />
          <Route path='/UpdateStockV' element={<UpdateStockV />} />
          <Route path='/ChangeLocation' element={<ChangeLocation />} />
          <Route path='/Event' element={<Event />} />
          <Route path='/Pack' element={<PackManagement />} />
          <Route path='/Checkin' element={<CheckInSystem />} />
          <Route path='/SubscribersList' element={<SubscribersList />} />
          <Route path='/ProductRequest' element={<ProductRequestForm />} />
          <Route path='/CentralizedRequests' element={<CentralizedRequests />} />
          <Route path='/AdminApproval' element={<AdminApproval />} />
          <Route path='/PurchaseList' element={<PurchaseList />} />
          <Route path='/CategoryProductManager' element={<CategoryProductManager />} />
          <Route path='/GlobalDashbord' element={<GlobalDashboard />} />
          <Route path='/ticketpersonnel' element={<StaffCReport />} />
          <Route path='/PointsGestionT' element={<PointsGestion />} />
          <Route path='/EtatDepenses' element={<EtatDepenses />} />
          <Route path='/Rbe' element={<Rbe />} />
          <Route path='/ListRapport' element={<ListRapports />} />
          <Route path='/AddRapports' element={<Rapports />} />
          <Route path='/AddRapportsTwin' element={<RapportsTwin />} />
          <Route path='/ListeRapportsTwin' element={<ListeRapportsTwin />} />
          <Route path='/ListeRapportTwin' element={<ListeRapportsTwin />} />
          <Route path='/ListRapportsTwin' element={<ListeRapportsTwin />} />
          <Route path='/ListRapportTwin' element={<ListeRapportsTwin />} />
          <Route path='/GestionEmplacements' element={<GestionEmplacements />} />
          <Route path='/AddRapportsSpintoss' element={<RapportsSpintoss />} />
          <Route path='/ListRapportsSpintoss' element={<ListRapportsSpintoss />} />
          <Route path='/CollecteTwin' element={<CollecteTwin />} />
          <Route path='/ListeCollecteTwin' element={<ListCollectTwin />} />
          <Route path='/DeclarationEmployeur' element={<DeclarationEmployeur />} />

          {/* ── Ressources Humaines ── */}
          <Route path='/HR/pointage'  element={<PointagePage />} />
          <Route path='/HR/schedule'  element={<EmployeesSchedule />} />
          <Route path='/HR/dashboard' element={<HRDashboard />} />
          <Route path='/HR/employees' element={<EmployeeManager />} />
          <Route path='/HR/salary'    element={<SalaryManager />} />

          {/* ── Statistiques ── */}
          <Route path='/Statistiques/Wellness' element={<WellnessStats />} />
          <Route path='/Statistiques/Achats' element={<StatistiquesAchats />} />

          {/* ── Module Achats Quotidiens ── */}
          <Route path='/AchatsQuotidiens' element={<DailyPurchaseHub />} />

          {/* ── Module Transferts de Fonds & Monnaie ── */}
          <Route path='/TransfertsFonds' element={<FundTransferHub />} />
          <Route path='/transferts-fonds' element={<FundTransferHub />} />
          <Route path='/GestionAgentsTransfert' element={<GestionAgentsTransfert />} />
          <Route path='/gestion-agents-transfert' element={<GestionAgentsTransfert />} />
        </Route>

      </Routes>

    </div>
  );
}

export default App;
